import React from 'react'
import MainMqtt from './mqtt/MainMqqt'
import MainHistory from './history/MainHistory'


function MainChart({titles, url, dataTypes, barTypes}) {
  return (
    <>
 <MainMqtt
 titles = {titles}
 url = {url}
 dataTypes = {dataTypes}  
 barTypes = {barTypes}
 MainHistory={
 
 <MainHistory 
  titles = {titles}
  url = {url}
  dataTypes = {dataTypes}  
  barTypes = {barTypes}
  />
} 
 />


    </>
  )
}

export default MainChart